import { APAC_FLIGHT_NAME, ApacFlightsComponent } from "@apac/flights";
import {
  CoreFlightsComponent,
  CoreFlightsCfarExerciseComponents,
  CORE_FLIGHTS_NAME,
  CORE_FLIGHTS_CFAR_NAME,
  CoreFlightsCfarOffersComponents,
  CORE_AIR_PRICE_WATCH_NAME,
  CoreAirPriceWatchComponent,
  CORE_DISRUPTION_NAME,
  CoreDisruptionComponent,
} from "@b2bportal/core-types";

// apac flights overrides
import bookingConfirmationCardStyles from "./apac-flights/BookingConfirmationCard/BookingConfirmationCard.module.scss";
import cardPaymentStyles from "./apac-flights/CardPayment/CardPayment.module.scss";
import flightItineraryDetailAddOnsStyles from "./apac-flights/FlightItineraryDetailAddOns/styles.module.scss";
import flightItineraryBookingConfirmationStyles from "./apac-flights/FlightItineraryDetailBookingConfirmation/FlightItineraryDetailBookingConfirmation.module.scss";
import flightItineraryDetailPaymentStyles from "./apac-flights/FlightItineraryDetailPayment/FlightItineraryDetailPayment.module.scss";
import flightItineraryDetailSliceSummaryStyles from "./apac-flights/FlightItineraryDetailSliceSummary/style.module.scss";
import flightItineraryDetailSummaryStyles from "./apac-flights/FlightItineraryDetailSummary/styles.module.scss";
import flightItineraryDetailTravelersStyles from "./apac-flights/FlightItineraryDetailTravelers/FlightItineraryDetailTravelers.module.scss";
import flightItinerarySelfServeLinksStyles from "./apac-flights/FlightItinerarySelfServeLinks/FlightItinerarySelfServeLinks.module.scss";
import nonCardPaymentStyles from "./apac-flights/NonCardPayment/NonCardPayment.module.scss";
import paymentPerTravelerStyles from "./apac-flights/PaymentPerTraveler/PaymentPerTraveler.module.scss";
import tripTotalStyles from "./apac-flights/TripTotal/TripTotal.module.scss";
import watchLoadingScreenStyles from "./core-air-price-watch/WatchLoadingScreen/styles.module.scss";

// disruption overrides
import disruptionExerciseBulletPointStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseBulletPoint.module.scss";
import disruptionExerciseButton from "./core-disruption/DisruptionExercise/DisruptionExerciseButton.module.scss";
import disruptionExerciseContainerStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseContainer.module.scss";
import disruptionExerciseFooter from "./core-disruption/DisruptionExercise/DisruptionExerciseFooter.module.scss";
import disruptionExerciseHeaderStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseHeader.module.scss";
import disruptionExerciseInformationCardStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseInformationCard.module.scss";
import disruptionExerciseOptionsCardStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseOptionsCard.module.scss";
import disruptionExercisePolicyDetailsStyles from "./core-disruption/DisruptionExercise/DisruptionExercisePolicyDetails.module.scss";
import disruptionExerciseRefundConfirmationPageStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseRefundConfirmationPage.module.scss";
import disrutionExerciseRefundSummaryCardStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseRefundSummaryCard.module.scss";
import disruptionExerciseSegmentSelectCardStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseSegmentSelectCard.module.scss";
import disruptionExerciseSectionStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseSelection.module.scss";
import disruptionExerciseSummaryCardStyles from "./core-disruption/DisruptionExercise/DisruptionExerciseSummaryCard.module.scss";
import flightDisruptionAlertBannerStyles from "./core-disruption/DisruptionExercise/FlightDisruptionAlertBanner.module.scss";
import disruptionOfferSectionStyles from "./core-disruption/DisruptionOfferSection/styles.module.scss";
import howItWorksDialogStyles from "./core-disruption/HowItWorksDialog/styles.module.scss";
import disruptionMarketplaceProductStyles from "./core-disruption/styles/DisruptionFintechMarketplaceProduct.module.scss";
import airCfarExerciseLoadingScreenStyles from "./core-flights-cfar-exercise/AirCfarExerciseLoadingScreen/styles.module.scss";
import airCfarAirCfarExercisePageStyles from "./core-flights-cfar-exercise/AirCfarExercisePage/AirCfarExercisePage.module.scss";
import flightsCfarHowItWorksDialogStyleOverride from "./core-flights-cfar-offers/CfarHowItWorksDialog/styles.module.scss";
import flightsCfarStyleOverrides from "./core-flights-cfar-offers/CfarOffersection/styles.module.scss";
import cfarFintechMarketplaceProductStyles from "./core-flights-cfar-offers/styles/CfarFintechMarketplaceProduct.module.scss";

// flight overrides
import algomerchTagsOverrideStyles from "./flights/AlgomerchTags/styles.module.scss";
import calendarPickerStyles from "./flights/CalendarPicker/CalendarPicker.module.scss";
import changeFlightEligibilityModalStyles from "./flights/ChangeFlightEligibilityModal/ChangeFlightEligibilityModal.module.scss";
import flightListFareDetailsStyles from "./flights/FareDetails/styles.module.scss";
import flightCardOverrideStyles from "./flights/FlightCard/styles-override.module.scss";
import flightCardSummaryOverrideStyles from "./flights/FlightCardSummary/styles.module.scss";
import flightDepartureStyles from "./flights/FlightDeparturePage/styles.module.scss";
import flightDetailsSegmentStyles from "./flights/FlightDetailsSegment/styles.module.scss";
import flightExchangeConfirmationStyles from "./flights/FlightExchangeConfirmation/styles.module.scss";
import flightExchangeSliceDetailsCardStyles from "./flights/FlightExchangeSliceDetailsCard/styles.module.scss";
import flightFareGridStyles from "./flights/FlightFareGrid/styles.module.scss";
import flightItineraryCardOverrideStyles from "./flights/FlightItineraryCard/styles.module.scss";
import flightItineraryDetailPageOverrideStyles from "./flights/FlightItineraryDetailPage/styles.module.scss";
import flightReturnStyles from "./flights/FlightReturnPage/styles.module.scss";
import flightScheduleChangeBannerOverrideStyles from "./flights/FlightScheduleChangeBanner/styles.module.scss";
import flightSlicePickerModalStyles from "./flights/FlightSlicePickerModal/styles.module.scss";
import flightSummaryStyles from "./flights/FlightSummary/styles.module.scss";
import flightReviewFareSectionStyles from "./flights/ReviewFare/styles.module.scss";
import flightReviewFareStyles from "./flights/ReviewFarePage/styles.module.scss";
import flightReviewSecondaryContentStyles from "./flights/ReviewFlightSecondaryContent/styles.module.scss";
import flightReviewStyles from "./flights/ReviewPage/styles.module.scss";
import flightListGridFilterStyles from "./flights/styles/FlightListGridFilter.module.scss";
import flightsFintechMarketplacePageWrapperStyles from "./flights/styles/FlightsFintechMarketplacePageWrapper.module.scss";
import tripSummaryOverrideStyles from "./flights/TripSummary/styles.module.scss";

export const flightStylesOverrides = {
  [CORE_FLIGHTS_NAME]: {
    [CoreFlightsComponent.ChangeFlightEligibilityModal]:
      changeFlightEligibilityModalStyles,
    [CoreFlightsComponent.FlightExchangeConfirmation]:
      flightExchangeConfirmationStyles,
    [CoreFlightsComponent.FlightExchangeSliceDetailsCard]:
      flightExchangeSliceDetailsCardStyles,
    [CoreFlightsComponent.FlightListGridFilter]: flightListGridFilterStyles,
    [CoreFlightsComponent.DeparturePage]: flightDepartureStyles,
    [CoreFlightsComponent.ReturnPage]: flightReturnStyles,
    [CoreFlightsComponent.ReviewPage]: flightReviewStyles,
    [CoreFlightsComponent.ReviewFarePage]: flightReviewFareStyles,
    [CoreFlightsComponent.ReviewFlightSecondaryContent]:
      flightReviewSecondaryContentStyles,
    [CoreFlightsComponent.ReviewFare]: flightReviewFareSectionStyles,
    [CoreFlightsComponent.FlightSummary]: flightSummaryStyles,
    [CoreFlightsComponent.FlightDetailsSegment]: flightDetailsSegmentStyles,
    [CoreFlightsComponent.FlightsFintechMarketplacePageWrapper]:
      flightsFintechMarketplacePageWrapperStyles,
    [CoreFlightsComponent.FlightFareGrid]: flightFareGridStyles,
    [CoreFlightsComponent.FlightFareGridItem]: flightFareGridStyles,
    [CoreFlightsComponent.FareListFareDetails]: flightListFareDetailsStyles,
    [CoreFlightsComponent.FlightCard]: flightCardOverrideStyles,
    [CoreFlightsComponent.AlgomerchTags]: algomerchTagsOverrideStyles,
    [CoreFlightsComponent.CalendarPicker]: calendarPickerStyles,
    [CoreFlightsComponent.FlightCardSummary]: flightCardSummaryOverrideStyles,
    [CoreFlightsComponent.TripSummary]: tripSummaryOverrideStyles,
    [CoreFlightsComponent.FlightItineraryCard]:
      flightItineraryCardOverrideStyles,
    [CoreFlightsComponent.FlightItineraryDetailPage]:
      flightItineraryDetailPageOverrideStyles,
    [CoreFlightsComponent.FlightItineraryDetailSummary]:
      flightItineraryDetailSummaryStyles,
    [CoreFlightsComponent.FlightScheduleChangeBanner]:
      flightScheduleChangeBannerOverrideStyles,
    [CoreFlightsComponent.FlightSlicePickerModal]: flightSlicePickerModalStyles,
  },
  [CORE_AIR_PRICE_WATCH_NAME]: {
    [CoreAirPriceWatchComponent.WatchListLoadingScreen]:
      watchLoadingScreenStyles,
  },
  [CORE_FLIGHTS_CFAR_NAME]: {
    [CoreFlightsCfarOffersComponents.CfarOfferSection]:
      flightsCfarStyleOverrides,
    [CoreFlightsCfarOffersComponents.CfarFintechMarketplaceProduct]:
      cfarFintechMarketplaceProductStyles,
    [CoreFlightsCfarOffersComponents.CfarHowItWorksDialog]:
      flightsCfarHowItWorksDialogStyleOverride,
    [CoreFlightsCfarExerciseComponents.AirCfarExerciseLoadingScreen]:
      airCfarExerciseLoadingScreenStyles,
    [CoreFlightsCfarExerciseComponents.AirCfarExercisePage]:
      airCfarAirCfarExercisePageStyles,
  },
  [APAC_FLIGHT_NAME]: {
    [ApacFlightsComponent.FlightItineraryDetailSummary]:
      flightItineraryDetailSummaryStyles,
    [ApacFlightsComponent.FlightItineraryDetailAddOns]:
      flightItineraryDetailAddOnsStyles,
    [ApacFlightsComponent.FlightItineraryDetailSliceSummary]:
      flightItineraryDetailSliceSummaryStyles,
    [ApacFlightsComponent.FlightItineraryDetailTravelers]:
      flightItineraryDetailTravelersStyles,
    [ApacFlightsComponent.FlightItineraryDetailBookingConfirmation]:
      flightItineraryBookingConfirmationStyles,
    [ApacFlightsComponent.BookingConfirmationCard]:
      bookingConfirmationCardStyles,
    [ApacFlightsComponent.CardPayment]: cardPaymentStyles,
    [ApacFlightsComponent.NonCardPayment]: nonCardPaymentStyles,
    [ApacFlightsComponent.PaymentPerTraveler]: paymentPerTravelerStyles,
    [ApacFlightsComponent.TripTotal]: tripTotalStyles,
    [ApacFlightsComponent.FlightItineraryDetailPayment]:
      flightItineraryDetailPaymentStyles,
    [ApacFlightsComponent.FlightItinerarySelfServeLinks]:
      flightItinerarySelfServeLinksStyles,
  },
  [CORE_DISRUPTION_NAME]: {
    [CoreDisruptionComponent.DisruptionOfferSection]:
      disruptionOfferSectionStyles,
    [CoreDisruptionComponent.HowItWorksDialog]: howItWorksDialogStyles,
    [CoreDisruptionComponent.DisruptionExerciseButton]:
      disruptionExerciseButton,
    [CoreDisruptionComponent.DisruptionExerciseFooter]:
      disruptionExerciseFooter,
    [CoreDisruptionComponent.DisruptionExerciseHeader]:
      disruptionExerciseHeaderStyles,
    [CoreDisruptionComponent.DisruptionExerciseSummaryCard]:
      disruptionExerciseSummaryCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseSelection]:
      disruptionExerciseSectionStyles,
    [CoreDisruptionComponent.DisruptionExerciseContainer]:
      disruptionExerciseContainerStyles,
    [CoreDisruptionComponent.DisruptionExercisePolicyDetails]:
      disruptionExercisePolicyDetailsStyles,
    [CoreDisruptionComponent.DisruptionExerciseBulletPoint]:
      disruptionExerciseBulletPointStyles,
    [CoreDisruptionComponent.DisruptionExerciseInformationCard]:
      disruptionExerciseInformationCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseRefundSummaryCard]:
      disrutionExerciseRefundSummaryCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseRefundConfirmationPage]:
      disruptionExerciseRefundConfirmationPageStyles,
    [CoreDisruptionComponent.DisruptionExerciseSegmentSelectCard]:
      disruptionExerciseSegmentSelectCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseOptionsCard]:
      disruptionExerciseOptionsCardStyles,
    [CoreDisruptionComponent.DisruptionFintechMarketplaceProduct]:
      disruptionMarketplaceProductStyles,
    [CoreDisruptionComponent.FlightDisruptionAlertBanner]:
      flightDisruptionAlertBannerStyles,
  },
};
